import { useIntl } from "react-intl";

import { CompoundSubNavProps } from "@/patterns/global-nav/src/nav-global-compound-subnav";

export const CollectionsCompoundSubNavProps = () => {
    const intl = useIntl();
    const props: CompoundSubNavProps = {
        compoundSubNavTitle: "Collections",
        compoundSubNavLinksProps: [
            {
                globalLinksKey: "overview",
                linkText: intl.formatMessage({
                    id: "collectionsCompoundSubNav.Navlink.overview",
                    defaultMessage: "Overview"
                }),
                hasSubnav: false,
                href: "/collections"
            },
            {
                globalLinksKey: "teamwork",
                linkText: "Teamwork",
                hasSubnav: false,
                href: "/collections/teamwork"
            },
            {
                globalLinksKey: "strategy",
                linkText: "Strategy",
                hasSubnav: false,
                href: "/collections/strategy"
            }
        ],
        isShowCta: true,
        ctaButtonText: intl.formatMessage({
            id: "collectionsCompoundSubNav.cta.contactSales",
            defaultMessage: "Contact Sales"
        }),
        ctaButtonVariant: "primary",
        ctaUrl: "#contact"
    };
    return props;
};
